import React from 'react';

// v9: the hoc
import { withNamespaces } from 'react-i18next';
import i18n from 'src/i18n';

// 垃圾 detector 一點屁用也沒有，只好自己用 cookie 幹
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export default withNamespaces()(LanguageBar);
function LanguageBar(props) {
  const { t } = props;
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    cookies.set('language', lng, { path: '/' });
  }
  return (
    <div>
      <button
        className={'btn m-2 ' + (i18n.language === 'zh-TW' ? 'btn-info' : 'btn-outline-info')}
        onClick={() => changeLanguage('zh-TW')}>{t('i18n.zh-TW')}</button>
      <button
        className={'btn m-2 ' + (i18n.language === 'ja-JP' ? 'btn-info' : 'btn-outline-info')}
        onClick={() => changeLanguage('ja-JP')}>{t('i18n.ja-JP')}</button>
      <button
        className={'btn m-2 ' + (i18n.language === 'en' ? 'btn-info' : 'btn-outline-info')}
        onClick={() => changeLanguage('en')}>{t('i18n.en')}</button>
    </div>
  );
}
